import React from 'react'
import { Footer } from '@pmndrs/branding'

export default function Overlay({ ready, clicked, setClicked }) {
  return (
    <>
      <div className={`fullscreen bg ${ready ? 'ready' : 'notready'} ${clicked && 'clicked'}`}>
        <div onClick={() => ready && setClicked(true)}>{!ready ? 'loading' : 'click to continue'}</div>
      </div>
      <div className="pmndrs-menu">
        <div>
        </div>
        <div>
          <span><b></b></span>
          <a target="_blank" rel="noopener noreferrer" href="https://github.com/dialnco">dialnco | github</a>
          <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/dialnco/">@dialnco</a>
        </div>
        <div>
          <span>01. Feb</span><span>2021</span>
        </div>
        <div>
          <span>Open Source</span><span>Developer collective</span>
        </div>
        <div style={{ width: '100%' }}>
        <a target="_blank" rel="noopener noreferrer" href="https://github.com/dialnco">dialnco</a>
        <a target="_blank" rel="noopener noreferrer" href="https://github.com/pmndrs/drei">pmndrs/drei</a>
        </div>
        <div>
          <b><a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/watch?v=fn3KWM1kuAw">Do You Love Me? | @Boston Dynamics</a></b>
        </div>
    </div>
    </>
  )
}
